export default __webpack_public_path__ + "static/media/OSMOS_TORTORA-RIBBED_60X120_modulo_ribbed.d9106a81.jpg";